import * as React from 'react';
import * as styles from './styles.css';

import { UIHeading3, UIText1, ModalWindow, IconChevronRight16 } from '@cian/ui-kit';
import { IconPlaceholderCardAgent16, IconActionAdvert16 } from '@cian/ui-kit-design-tokens/icons';

import saleByCianImg from './assets/saleByCian.svg';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

interface IHelpByCianProps {
  isDesktop: boolean;
  isOpen: boolean;

  headingTitle: string;

  agentTitle: string;
  agentDescription: string;

  openAgentForm(): void;

  openNewOffer(): void;

  onClose(): void;

  onModalShow(): void;
}

export const HelpByCian: React.FC<IHelpByCianProps> = ({
  isDesktop,
  isOpen,
  onClose,
  headingTitle,
  agentTitle,
  agentDescription,
  openAgentForm,
  openNewOffer,
  onModalShow,
}) => {
  return (
    <ModalWindow
      open={isOpen}
      onClose={onClose}
      size="M"
      fixed
      width={648}
      title={isDesktop ? undefined : headingTitle}
      content={
        <ActionAfterViewObserver callback={onModalShow}>
          <>
            {isDesktop && (
              <div className={styles['img']}>
                <img src={saleByCianImg} />
              </div>
            )}
            <div>
              <div className={styles['control']} onClick={openAgentForm}>
                <div className={styles['control-content']}>
                  <div className={styles['icon']}>
                    <IconPlaceholderCardAgent16 color="icon-inverted-default" />
                  </div>
                  <div>
                    <UIHeading3 as="div">{agentTitle}</UIHeading3>
                    <UIText1 color="gray60_100">{agentDescription}</UIText1>
                  </div>
                </div>
                <div>
                  <IconChevronRight16 />
                </div>
              </div>
              <div className={styles['control']} onClick={openNewOffer}>
                <div className={styles['control-content']}>
                  <div className={styles['icon']}>
                    <IconActionAdvert16 color="icon-inverted-default" />
                  </div>
                  <div>
                    <UIHeading3 as="div">Самостоятельно</UIHeading3>
                    <UIText1 color="gray60_100">Бесплатно для собственников жилой недвижимости</UIText1>
                  </div>
                </div>
                <div>
                  <IconChevronRight16 />
                </div>
              </div>
            </div>
          </>
        </ActionAfterViewObserver>
      }
    />
  );
};

HelpByCian.displayName = 'HelpByCian';
